<template>
  <nav :class="`font-grotesque navigation navigation-${popup ? 'popup-open' : ''} navigation-${theme}`">
    <div :class="`navigation-animation navigation-animation-${animation ? 'loaded' : ''}`">
      <NavigationMenu :alternative="alternative" parent="7"/>
      <!-- <div :class="`phone phone-${animation ? 'active' : ''}`">+7 (495) 933-70-86</div> -->
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import NavigationMenu from '@/components/NavigationMenu';

export default {
  name: 'navigation',
  props: ['alternative'],
  components: {
    NavigationMenu,
  },
  computed: mapGetters({
    theme: 'navigationTheme',
    animation: 'animation',
    popup: 'popup',
    lang: 'lang',
  }),
  created() {
    this.$store.dispatch('fetchNavigation', { lang: this.lang });
  },
  watch: {
    lang() {
      this.$store.dispatch('fetchNavigation', { lang: this.lang });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.navigation{
  transition: all .3s ease-in-out;
  vertical-align: middle;
  display: inline-block;
  position: relative;
  padding-left: 40px;
  margin-left: 0;
  max-width: 680px;
  z-index: 90;
  left: 0;
  top: 0;

  .page-theme-white .page-back & {
    opacity: 0;
  }

  @media (max-width: $mediaLaptop) {
    font-size: 85%;
  }

  @media (max-width: $mediaMob) {
    font-size: 80%;
  }

  @media (max-width: $mediaMini) {
    padding: 0 30px;
  }

  .phone{
    transition: all .5s ease-in-out;
    display: inline-block;
    font-weight: 600;
    margin-left: 10%;
    font-size: 110%;
    color: black;
    opacity: 0;

    @media (max-width: $mediaMini) {
      margin-top: 10px;
      display: none;
    }

    &-active{
      opacity: 1;
    }
  }


  li {
    vertical-align: top;
    margin-top: 5px;
  }

  a{
    color: black;
    transition: color .2s ease-in-out;
    &,
    &:hover{
      border-bottom: 0;
      text-decoration: none;
    }
    &:hover{
      color: #ff9933 !important;
    }
  }

  &-popup-open,
  &-white{
    &,
    a{
      color: white;

      &.router-link-exact-active{
        color: $brand;
      }
    }
    .phone{
      color: white;
    }
  }


  &-active{
    color: black;
  }

  &-popup-open{
    .navigation-menu-li {
      transition-delay: 0 !important;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue